<template>
  <div class="income-page">
    <h2>Pemasukan</h2>

    <form @submit.prevent="addTransaction" class="transaction-form">
      <h3>Tambah Pemasukan Baru</h3>
      <div class="form-group">
        <label for="income-date">Tanggal:</label>
        <input type="date" id="income-date" v-model="newTransaction.date" required>
      </div>
      <div class="form-group">
        <label for="income-description">Deskripsi:</label>
        <input type="text" id="income-description" v-model="newTransaction.description" placeholder="Gaji, bonus, dll." required>
      </div>
      <div class="form-group">
        <label for="income-amount">Jumlah:</label>
        <input type="number" id="income-amount" v-model.number="newTransaction.amount" min="0" step="0.01" required>
      </div>
      <button type="submit" class="submit-button">Tambah Pemasukan</button>
    </form>

    <hr>

    <h3>Daftar Pemasukan Anda</h3>
    <div v-if="incomes.length > 0" class="transaction-list">
      <table>
        <thead>
          <tr>
            <th>Tanggal</th>
            <th>Deskripsi</th>
            <th class="text-right">Jumlah</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="income in incomes" :key="income.ID">
            <td>{{ new Date(income.date).toLocaleDateString('id-ID') }}</td>
            <td>{{ income.description }}</td>
            <td class="text-right">Rp {{ income.amount.toLocaleString('id-ID') }}</td>
            <td>
              <button @click="openEditModal(income)" class="btn btn-edit">Edit</button>
              <button @click="deleteTransaction(income.ID)" class="btn btn-delete">Hapus</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p>Tidak ada pemasukan yang ditemukan.</p>
    </div>

    <p v-if="error" class="error-message">{{ error }}</p>

    <div v-if="showEditModal" class="modal-overlay">
      <div class="modal-content">
        <h3>Edit Pemasukan</h3>
        <form @submit.prevent="saveEditedTransaction">
          <div class="form-group">
            <label for="edit-date">Tanggal:</label>
            <input type="date" id="edit-date" v-model="editingTransaction.date" required>
          </div>
          <div class="form-group">
            <label for="edit-description">Deskripsi:</label>
            <input type="text" id="edit-description" v-model="editingTransaction.description" required>
          </div>
          <div class="form-group">
            <label for="edit-amount">Jumlah:</label>
            <input type="number" id="edit-amount" v-model.number="editingTransaction.amount" min="0" step="0.01" required>
          </div>
          <div class="modal-actions">
            <button type="submit" class="btn btn-primary">Simpan Perubahan</button>
            <button type="button" @click="closeEditModal" class="btn btn-secondary">Batal</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2'; // Impor SweetAlert2

export default {
  name: 'IncomePage',
  data() {
    return {
      incomes: [],
      newTransaction: {
        date: new Date().toISOString().split('T')[0],
        description: '',
        amount: 0,
        type: 'income',
      },
      error: null,
      showEditModal: false,
      editingTransaction: {
        id: null,
        date: '',
        description: '',
        amount: 0,
        type: 'income',
      },
    };
  },
  methods: {
    async apiCall(url, method = 'GET', data = null) {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$router.push('/login');
        // Gunakan SweetAlert2 untuk pesan error token
        Swal.fire({
          icon: 'error',
          title: 'Akses Ditolak!',
          text: 'Anda perlu login untuk mengakses halaman ini.',
          confirmButtonText: 'OK'
        });
        throw new Error('No token found, redirecting to login.');
      }

      try {
        const response = await axios({
          url,
          method,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          data: data,
        });
        return response.data;
      } catch (err) {
        this.error = err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : `Terjadi kesalahan: ${err.message}`;
        console.error('API Call Error:', err.response || err);
        // Tampilkan error menggunakan SweetAlert2
        Swal.fire({
          icon: 'error',
          title: 'Gagal!',
          text: this.error,
          confirmButtonText: 'OK'
        });
        throw err;
      }
    },

    async fetchTransactions() {
      try {
        this.error = null;
        this.incomes = await this.apiCall('https://api.pala.linksoftindo.com/api/transactions/?type=income&userID=true', 'GET');
      } catch (err) {
        this.incomes = []; // Kosongkan data jika ada error fetch
      }
    },

    async addTransaction() {
      try {
        this.error = null;
        await this.apiCall(
          'https://api.pala.linksoftindo.com/api/transactions/',
          'POST',
          this.newTransaction
        );

        // Notifikasi sukses menggunakan SweetAlert2
        Swal.fire({
          icon: 'success',
          title: 'Berhasil!',
          text: 'Pemasukan berhasil ditambahkan.',
          timer: 1500,
          showConfirmButton: false
        });

        this.fetchTransactions();
        this.newTransaction.description = '';
        this.newTransaction.amount = 0;
        this.newTransaction.date = new Date().toISOString().split('T')[0];
      } catch (err) {
        // Error sudah ditangani di apiCall, tidak perlu alert lagi di sini
        console.error('Error adding income:', err);
      }
    },

    openEditModal(transaction) {
      this.editingTransaction = { ...transaction };
      this.editingTransaction.date = new Date(transaction.date).toISOString().split('T')[0];
      this.showEditModal = true;
    },

    closeEditModal() {
      this.showEditModal = false;
      this.editingTransaction = {
        id: null,
        date: new Date().toISOString().split('T')[0],
        description: '',
        amount: 0,
        type: 'income',
      };
      this.error = null;
    },

    async saveEditedTransaction() {
      try {
        this.error = null;
        const transactionDetailsPayload = {
          description: this.editingTransaction.description,
          amount: parseFloat(this.editingTransaction.amount),
          date: this.editingTransaction.date,
          type: this.editingTransaction.type,
        };

        await this.apiCall(
          `https://api.pala.linksoftindo.com/api/transactions/${this.editingTransaction.ID}`,
          'PUT',
          transactionDetailsPayload
        );

        // Notifikasi sukses menggunakan SweetAlert2
        Swal.fire({
          icon: 'success',
          title: 'Berhasil!',
          text: 'Pemasukan berhasil diperbarui.',
          timer: 1500,
          showConfirmButton: false
        });

        this.closeEditModal();
        this.fetchTransactions();
      } catch (err) {
        console.error('Error saving edited income:', err);
      }
    },

    async deleteTransaction(transactionId) {
      // Ganti `confirm` dengan SweetAlert2
      const result = await Swal.fire({
        title: 'Anda Yakin?',
        text: "Anda tidak akan dapat mengembalikan ini!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, Hapus!',
        cancelButtonText: 'Batal'
      });

      if (result.isConfirmed) {
        try {
          this.error = null;
          await this.apiCall(`https://api.pala.linksoftindo.com/api/transactions/${transactionId}`, 'DELETE');

          // Notifikasi sukses hapus menggunakan SweetAlert2
          Swal.fire(
            'Dihapus!',
            'Pemasukan Anda telah dihapus.',
            'success'
          );
          this.fetchTransactions();
        } catch (err) {
          console.error('Error deleting income:', err);
        }
      }
    }
  },
  async created() {
    await this.fetchTransactions();
  }
};
</script>

<style scoped>
/* Styling dasar untuk halaman pemasukan */
.income-page {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h2, h3 {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 30px 0;
}

/* Styling untuk formulir transaksi */
.transaction-form {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #555;
  font-weight: bold;
}

.form-group input[type="date"],
.form-group input[type="text"],
.form-group input[type="number"] {
  width: calc(100% - 22px); /* Adjust for padding and border */
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.submit-button {
  background-color: #4CAF50; /* Hijau */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  background-color: #45a049;
}

/* Styling untuk daftar transaksi (tabel) */
.transaction-list table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden; /* Ensures rounded corners apply to content */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.transaction-list th,
.transaction-list td {
  border: 1px solid #eee;
  padding: 12px 15px;
  text-align: left;
}

.transaction-list th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #666;
}

.transaction-list tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.transaction-list tbody tr:hover {
  background-color: #f1f1f1;
}

.error-message {
  color: #d9534f; /* Merah */
  background-color: #f2dede;
  border: 1px solid #ebccd1;
  padding: 10px;
  border-radius: 4px;
  margin-top: 20px;
  text-align: center;
}

/* --- New Styles for Modal and Buttons --- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  width: 90%;
  max-width: 500px;
}

.modal-content h3 {
  text-align: center;
  margin-bottom: 25px;
  color: #333;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 25px;
}

.btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  margin-right: 5px; /* Adjust spacing between buttons */
}

.btn-edit {
  background-color: #2196F3; /* Blue */
  color: white;
}

.btn-edit:hover {
  background-color: #0b7dda;
}

.btn-delete {
  background-color: #f44336; /* Red */
  color: white;
}

.btn-delete:hover {
  background-color: #da190b;
}

.btn-primary { /* For modal save button */
  background-color: #4CAF50; /* Green */
  color: white;
}

.btn-secondary { /* For modal cancel button */
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
}

.text-right {
  text-align: right!important;
}

.income-page {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h2, h3 {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 30px 0;
}

.transaction-form {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #555;
  font-weight: bold;
}

.form-group input[type="date"],
.form-group input[type="text"],
.form-group input[type="number"] {
  width: calc(100% - 22px);
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.submit-button {
  background-color: #4CAF50;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  background-color: #45a049;
}

.transaction-list table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.transaction-list th,
.transaction-list td {
  border: 1px solid #eee;
  padding: 12px 15px;
  text-align: left;
}

.transaction-list th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #666;
}

.transaction-list tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.transaction-list tbody tr:hover {
  background-color: #f1f1f1;
}

.text-right {
  text-align: right;
}

.error-message {
  color: #d9534f;
  background-color: #f2dede;
  border: 1px solid #ebccd1;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
}

/* --- Gaya untuk Modal dan Tombol Aksi --- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  width: 90%;
  max-width: 500px;
}

.modal-content h3 {
  text-align: center;
  margin-bottom: 25px;
  color: #333;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 25px;
}

.btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  margin-right: 5px;
}

.btn-edit {
  background-color: #2196F3;
  color: white;
}

.btn-edit:hover {
  background-color: #0b7dda;
}

.btn-delete {
  background-color: #f44336;
  color: white;
}

.btn-delete:hover {
  background-color: #da190b;
}

.btn-primary {
  background-color: #4CAF50;
  color: white;
}

.btn-secondary {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
}
</style>